import axios from "axios";
import coments from "../../models/coments/coments";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  getComent() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.get(`${url}/coments/all`, { headers }).then(({ data }) =>
      data.map((item) => {
        return coments.fromJson(item);
      })
    );
  }

  new(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.post(`${url}/coments`, data, { headers });
  }

  edit(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    let payload = {};
    if (data.hasOwnProperty("comentario")) {
      payload.comentario = data.comentario;
    }
    if (data.hasOwnProperty("codAplica")) {
      payload.codAplica = data.codAplica;
    }
    return axios.patch(`${url}/coments/${data.comentId}`, payload, { headers });
  }

  delete(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.delete(`${url}/coments/${data}`, {
      headers,
    });
  }
}
export default service;
